import React, { memo, useEffect, useState, useImperativeHandle } from 'react';
import { Form, Input, Button } from 'antd';
import { individualTargetData } from '@model/projectDetails';
import { connect } from 'react-redux';
import action from '@flux/action';
import useTheme from '@hooks/useTheme';
import { scrollToTopAnimation } from '@utils/common';
const Item = Form.Item;
const { TextArea } = Input;

function TargetCompany(props) {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  const { settingProjectData, settingData, cRef, common } = props;
  const [form] = Form.useForm();
  const [scrollToTop] = useState();
  const data = {};
  useImperativeHandle(cRef, () => ({
    subTwoForm: form,
  }));
  useEffect(() => {
    scrollToTopAnimation({ y: 260 });
  }, [scrollToTop]);
  settingData?.targetCompanyInfo &&
    Object.keys(settingData?.targetCompanyInfo).map((item) => {
      if (
        item === 'employeeHeadcount' ||
        item === 'estimatedTotalRevenue' ||
        item === 'estimatedMarketCap'
      ) {
        data[`SUBTWO${item}`] = settingData.targetCompanyInfo[item]
          ? `${settingData.targetCompanyInfo[item]}`.replace(
              /(\d)(?=(\d{3})+$)/g,
              '$1,',
            )
          : '';
      } else {
        data[`SUBTWO${item}`] = settingData.targetCompanyInfo[item];
      }
      return data;
    });

  const renderItem = (item, idx) => {
    if (item.type === 'Input') {
      return (
        <Item
          label={item.label}
          name={item.name}
          style={{ ...item.style }}
          key={idx + item.name}
          rules={[
            {
              required: item.required,
              whitespace: true,
              pattern: item.pattern,
              message: item.message,
            },
          ]}
        >
          <Input
            maxLength={255}
            onChange={(e) => {
              const itemName = item.name && item.name.substring(6);
              let val;
              if (
                e.target.value &&
                (itemName === 'employeeHeadcount' ||
                  itemName === 'estimatedTotalRevenue' ||
                  itemName === 'estimatedMarketCap')
              ) {
                const num = e.target.value.replace(/,/g, '');
                form.setFieldsValue({
                  [item.name]: num.replace(/(\d)(?=(\d{3})+$)/g, '$1,'),
                });
                val = Number(form.getFieldValue(item.name).replace(/,/g, ''));
                form.validateFields([item.name]);
              } else {
                val = e.target.value;
              }

              settingProjectData({
                targetCompanyInfo: {
                  ...settingData.targetCompanyInfo,
                  [itemName]: val,
                },
              });
            }}
          />
        </Item>
      );
    }
    if (item.type === 'textArea') {
      return (
        <Item
          label={item.label}
          name={item.name}
          style={{ ...item.style }}
          key={item.name + idx}
        >
          <TextArea
            style={{ resize: 'none' }}
            onChange={(e) => {
              const itemName = item.name && item.name.substring(6);
              const val = e.target.value;

              settingProjectData({
                targetCompanyInfo: {
                  ...settingData.targetCompanyInfo,
                  [itemName]: val,
                },
              });
            }}
          />
        </Item>
      );
    }

    return (
      <div
        style={{ ...item.style, ...(isLightMode ? { color: '#474747' } : {}) }}
        key={idx + item.name}
      >
        {item.text}
        <span style={{ fontWeight: 700 }}>{item.companyName}</span>
      </div>
    );
  };
  const onFinish = () => {
    if (settingData.buyerManualInputFlag) {
      settingProjectData({ currentNum: 2 });
    } else {
      settingProjectData({ currentNum: 1 });
    }
  };

  const showSkipBtn = !common?.projectCompanyInfo?.targetName;
  const onPrevious = () => {
    if (showSkipBtn) {
      onFinish();
    } else {
      form
        .validateFields()
        .then(onFinish)
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const skipHandler = () => {
    settingProjectData({ currentNum: 1 });
    const targetCompanyInfoForSkip = {
      name: null,
      parentCompany: null,
      companyWebsite: null,
      description: null,
      industry: null,
      headquarters: null,
      incorporationDate: null,
      employeeHeadcount: null,
      estimatedTotalRevenue: null,
      estimatedMarketCap: null,
    };
    settingProjectData({ targetCompanyInfo: targetCompanyInfoForSkip });
  };

  return (
    <Form
      onFinish={onFinish}
      name="createProject"
      form={form}
      initialValues={data}
      layout="vertical"
      autoComplete="off"
    >
      {Array.isArray(individualTargetData) &&
        individualTargetData.map((item, idx) => renderItem(item, idx))}
      <div className="form-actions-wrapper setting-btns">
        <Button htmlType="button" className="previous-btn" onClick={onPrevious}>
          previous
        </Button>
        {showSkipBtn ? (
          <Button htmlType="button" className="skip-btn" onClick={skipHandler}>
            skip
          </Button>
        ) : null}
      </div>
    </Form>
  );
}

const mapStateToProps = ({ projects, common }) => ({
  projectFormData: projects.projectFormData,
  settingData: projects.settingData,
  common,
});

const mapDispatchToProps = (dispatch) => ({
  settingProjectData(data) {
    dispatch(action.settingProjectData(data));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(TargetCompany));
